import Box from '@mui/material/Box';
import { RHFAutoCompleteVirtualize } from '@openx/components-core/lib/AutoComplete/RHFAutoCompleteVirtualize';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { useTranslation } from 'react-i18next';
import { useProviderContext } from '../../../utils/context/ProviderContext';
import { providerFields } from '../../constants';

export const AllowedOrganizationsSection = () => {
  const { t } = useTranslation();
  const { useAccountOptionsFetch } = useProviderContext();
  const { account, accountOptionsLoading, error } = useAccountOptionsFetch();

  if (error) throw new Error('Account Options Error');

  return (
    <Box sx={{ flex: 1 }}>
      <FormSection divider title={t('Allowed Organizations')} rightColumnSize={RIGHT_COLUMN_WIDTH}>
        <RHFAutoCompleteVirtualize
          data-test="allowed-accounts-input"
          getOptionLabel={option => option.name}
          isOptionEqualToValue={(option, value) => {
            if (typeof value === 'object') {
              return option.id === value.id;
            }
            return false;
          }}
          limitTags={6}
          loading={accountOptionsLoading}
          multiple
          name={providerFields.ALLOWED_ACCOUNTS}
          options={account}
          textFieldProps={{
            label: t('Linked Organizations'),
            placeholder: t('[ Select Linked Organizations ]'),
          }}
        />
      </FormSection>
    </Box>
  );
};
